import { doc, getDoc, getFirestore, serverTimestamp, setDoc } from './instrumentedFirestore';
import { getFirebaseApp } from './app';
import { COLLECTIONS } from '@constants/firestorePaths';

const STUDENT_PORTAL_DOC_ID = 'studentPortal';

function db() {
    return getFirestore(getFirebaseApp());
}

function stripUndefined(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    const next = {};
    for (const [k, v] of Object.entries(obj)) {
        if (typeof v === 'undefined') continue;
        next[k] = v;
    }
    return next;
}

export async function getStudentPortalDownloadConfig() {
    const ref = doc(db(), COLLECTIONS.APP_SETTINGS, STUDENT_PORTAL_DOC_ID);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
        return {
            apkUrl: '',
            apkVersion: '',
            installVideoUrl: '',
            teacherApkUrl: '',
            teacherApkVersion: '',
            teacherInstallVideoUrl: '',
        };
    }
    const data = snap.data() || {};
    return {
        apkUrl: String(data.apkUrl || ''),
        apkVersion: String(data.apkVersion || ''),
        installVideoUrl: String(data.installVideoUrl || ''),
        teacherApkUrl: String(data.teacherApkUrl || ''),
        teacherApkVersion: String(data.teacherApkVersion || ''),
        teacherInstallVideoUrl: String(data.teacherInstallVideoUrl || ''),
    };
}

export async function saveStudentPortalDownloadConfig({ apkUrl, apkVersion, installVideoUrl, teacherApkUrl, teacherApkVersion, teacherInstallVideoUrl, updatedByUid }) {
    const ref = doc(db(), COLLECTIONS.APP_SETTINGS, STUDENT_PORTAL_DOC_ID);
    const payload = stripUndefined({
        apkUrl: String(apkUrl || '').trim(),
        apkVersion: String(apkVersion || '').trim(),
        installVideoUrl: String(installVideoUrl || '').trim(),
        teacherApkUrl: String(teacherApkUrl || '').trim(),
        teacherApkVersion: String(teacherApkVersion || '').trim(),
        teacherInstallVideoUrl: String(teacherInstallVideoUrl || '').trim(),
        updatedByUid: String(updatedByUid || ''),
        updatedAt: serverTimestamp(),
    });
    await setDoc(ref, payload, { merge: true });
    return payload;
}
